import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { ShutdownComponent } from './shutdown.component';

@NgModule({
  declarations: [ShutdownComponent],
  imports: [SharedModule]
})
export class ShutdownModule {}
